module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/OatmealPro2-Bold.f3247de5.woff";